'use client';

import { type PropsWithChildren, createContext, useContext, useState } from 'react';
export enum EXTENSION {
  STICKER = 'sticker',
  RAIN = 'rain',
  COMMAND = 'command',
  RULES = 'rules',
  EMOJI = 'emoji',
}
export type ChatContextProps = {
  activeExtension: EXTENSION | null;
  setActiveExtension: (modal: EXTENSION | null) => void;
};
const ChatContext = createContext<ChatContextProps | null>(null);
export const ChatProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [activeExtension, setActiveExtension] = useState<EXTENSION | null>(null);
  return <ChatContext.Provider value={{
    activeExtension,
    setActiveExtension
  }}>
      {children}
    </ChatContext.Provider>;
};
export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};